import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useSearchBox } from 'react-instantsearch';

/**
 * Syncs the parent Algolia index's search query into a secondary <Index>.
 * Required because each <Index> maintains its own query state, so when the
 * user types in the primary SearchBox we need to mirror that query into
 * the secondary index to keep results in sync.
 */
const VirtualSearchBox = t0 => {
  const $ = _c(5);
  const {
    parentQuery
  } = t0;
  const {
    query,
    refine
  } = useSearchBox();
  let t1;
  let t2;
  if ($[0] !== parentQuery || $[1] !== query || $[2] !== refine) {
    t1 = () => {
      if (parentQuery && parentQuery !== query) {
        refine(parentQuery);
      }
    };
    t2 = [parentQuery, query, refine];
    $[0] = parentQuery;
    $[1] = query;
    $[2] = refine;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return null;
};
export default VirtualSearchBox;